module.exports = __webpack_public_path__ + "img/icon_project06.488dc83d.png";